import React, { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormSelect } from 'components/Form'
import { PRODUCT_TRACK_STATUS_OPTIONS } from 'shared/consts'
import { IProductForm } from '../types'

import { IFieldProps } from './field.props'

export const StatusField: FC<IFieldProps> = ({ idx }) => {
  const { control } = useFormContext<IProductForm>()

  return (
    <FormSelect
      control={control}
      placeholder="-- No Track Status--"
      fieldName={`products.${idx}.gps_status`}
      options={PRODUCT_TRACK_STATUS_OPTIONS}
    />
  )
}
